
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCow, faHouse, faUser } from "@fortawesome/free-solid-svg-icons";
import { cn } from "../lib/utils";

const ReliableBottomNav = () => {
  const location = useLocation();

  // Don't show on auth pages
  if (location.pathname === '/auth' || location.pathname.startsWith('/auth?')) {
    return null;
  }

  return (
    <nav 
      data-testid="reliable-bottom-nav"
      className="fixed bottom-0 left-0 right-0 w-full z-[9998] bg-white"
      style={{
        position: 'fixed !important' as any,
        bottom: '0 !important',
        left: '0 !important',
        right: '0 !important',
        zIndex: 9998,
        paddingBottom: 'max(env(safe-area-inset-bottom, 16px), 16px)',
        transform: 'translateZ(0)',
        WebkitTransform: 'translateZ(0)',
        willChange: 'transform',
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden',
        display: 'block',
        visibility: 'visible',
        opacity: 1,
        pointerEvents: 'auto',
        isolation: 'isolate',
        contain: 'layout style paint',
        backgroundColor: 'white'
      }}
    >
      <div className="p-4 pb-2">
        <div 
          className="max-w-screen-lg mx-auto rounded-lg bg-white"
          style={{
            boxShadow: '0 0 16px rgba(0, 0, 0, 0.08)'
          }}
        >
          <div className="flex items-center justify-around px-4 py-3">
            <Link
              to="/dashboard"
              className={cn(
                "flex flex-col items-center justify-center p-2 transition-colors min-w-[60px]",
                location.pathname === "/dashboard"
                  ? "text-[#0747a1]"
                  : "text-black hover:text-[#0747a1]"
              )}
            >
              <FontAwesomeIcon icon={faHouse} className="h-5 w-5 mb-1" />
              <span className="text-xs font-medium">Dashboard</span>
            </Link>

            <Link
              to="/animals"
              className={cn(
                "flex flex-col items-center justify-center p-2 transition-colors min-w-[60px]",
                location.pathname === "/animals"
                  ? "text-[#0747a1]"
                  : "text-black hover:text-[#0747a1]"
              )}
            >
              <FontAwesomeIcon icon={faCow} className="h-5 w-5 mb-1" />
              <span className="text-xs font-medium">Animals</span>
            </Link>

            <Link
              to="/account"
              className={cn(
                "flex flex-col items-center justify-center p-2 transition-colors min-w-[60px]",
                location.pathname.startsWith("/account")
                  ? "text-[#0747a1]"
                  : "text-black hover:text-[#0747a1]"
              )}
            >
              <FontAwesomeIcon icon={faUser} className="h-5 w-5 mb-1" />
              <span className="text-xs font-medium">Account</span>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default ReliableBottomNav;
